<template>
    <div class="insp-section">
        <div style="display: flex; align-items: center; justify-content: space-between;" :style="{ 'padding-bottom' : (toggle) ? '8px' : '0px' }">
            <div class="insp-title"><slot name="title"></slot></div>
            <button v-if="toggleButton" class="icon" @click="$emit('setSelected', 'enabled', !toggle)">
                <span v-if="!toggle">＋</span>
                <span v-else>−</span>
            </button>
        </div>
        <slot name="inputs" v-if="toggle"></slot>
    </div>
</template>

<script>
export default {
    name: "SectionComp",
    props: {
        setkey: {
            type: String,
            required: false
        },
        toggle: {
            type: Boolean,
            required: false,
            default: false
        },
        toggleButton: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: ['setSelected']
}
</script>

<style scoped>
.icon { height: 24px; min-width: 24px; padding: 0 6px; border-radius: 6px; border: 1px solid var(--border); background: var(--panel); color: var(--text); cursor: pointer; font-size: 12px; }
.inspector { border-left: 1px solid var(--border); background: var(--panel); display: grid; grid-template-rows: auto 1fr; }
.inspector-tabs { display: flex; border-bottom: 1px solid var(--border); }
.inspector .tab { flex: 1; height: 36px; border: 0; background: transparent; color: var(--muted); cursor: pointer; }
.inspector .tab.active { color: var(--text); background: var(--panel); border-bottom: 2px solid var(--accent); }
.insp-scroll { overflow: auto; padding: 10px; }
.insp-section { padding: 10px; border: 1px solid var(--border); background: var(--panel); border-radius: 10px; margin-bottom: 10px; }
.insp-title { font-size: 11px; color: var(--muted); text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 0px; }
.grid { display: grid; gap: 8px; align-items: center; }
.g4 { grid-template-columns: 1fr 1fr 1fr 1fr; }
.g2 { grid-template-columns: 1fr 3fr; }
.row { display: flex; gap: 8px; align-items: center; }
.insp-section label { color: var(--muted); font-size: 12px; }
.insp-section input[type="number"], .insp-section input[type="text"], .insp-section select { width: 100%; height: 28px; border-radius: 6px; border: 1px solid var(--border); background: var(--panel); color: var(--text); padding: 0 8px; }
.insp-section input[type="color"] { width: 36px; height: 28px; border-radius: 6px; border: 1px solid var(--border); background: var(--panel); padding: 0; }
.hex { flex: 1; }
</style>
